//  Time-stamp: "2016-07-25 06:24:41 MDT"
module.exports = [
'Ie', 'Io', 'Dj', 'Gj', 'E', 'Dz', 'I', 'Yi', 'J', 'Lj', 'Nj', 'Tsh', 'Kj', 'I', 'U', 'Dzh',
'A', 'B', 'V', 'G', 'D', 'E', 'Zh', 'Z', 'I', 'I', 'K', 'L', 'M', 'N', 'O', 'P',
'R', 'S', 'T', 'U', 'F', 'Kh', 'Ts', 'Ch', 'Sh', 'Shch', "", 'Y', "'", 'E', 'Iu', 'Ia',
'a', 'b', 'v', 'g', 'd', 'e', 'zh', 'z', 'i', 'i', 'k', 'l', 'm', 'n', 'o', 'p',
'r', 's', 't', 'u', 'f', 'kh', 'ts', 'ch', 'sh', 'shch', "", 'y', "'", 'e', 'iu', 'ia',
'ie', 'io', 'dj', 'gj', 'ie', 'dz', 'i', 'yi', 'j', 'lj', 'nj', 'tsh', 'kj', 'i', 'u', 'dzh',
'O', 'o', 'E', 'e', 'Ie', 'ie', 'E', 'e', 'Ie', 'ie', 'O', 'o', 'Io', 'io', 'Ks', 'ks',
'Ps', 'ps', 'F', 'f', 'Y', 'y', 'Y', 'y', 'u', 'u', 'O', 'o', 'O', 'o', 'Ot', 'ot',
'Q', 'q', "*1000*", "", "", "", "", '[?]', "*100.000*", "*1.000.000*", '[?]', '[?]', "\"", "\"", "R'", "r'",
"G'", "g'", "G'", "g'", "G'", "g'", "Zh'", "zh'", "Z'", "z'", "K'", "k'", "K'", "k'", "K'", "k'",
"K'", "k'", "N'", "n'", 'Ng', 'ng', "P'", "p'", 'Kh', 'kh', "S'", "s'", "T'", "t'", 'U', 'u',
"U'", "u'", "Kh'", "kh'", 'Tts', 'tts', "Ch'", "ch'", "Ch'", "ch'", 'H', 'h', 'Ch', 'ch', "Ch'", "ch'",
"`", 'Zh', 'zh', "K'", "k'", '[?]', '[?]', "N'", "n'", '[?]', '[?]', 'Ch', 'ch', '[?]', '[?]', '[?]',
'a', 'a', 'A', 'a', 'Ae', 'ae', 'Ie', 'ie', "\\@", "\\@", "\\@", "\\@", 'Zh', 'zh', 'Z', 'z',
'Dz', 'dz', 'I', 'i', 'I', 'i', 'O', 'o', 'O', 'o', 'O', 'o', 'E', 'e', 'U', 'u',
'U', 'u', 'U', 'u', 'Ch', 'ch', '[?]', '[?]', 'Y', 'y', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
];
